// extracted by mini-css-extract-plugin
module.exports = {"overlay":"style_overlay__wYO67","spin":"style_spin__WBpOh"};